export const ToastSeverity = {
  SUCCESS: 'success',
  ERROR: 'error',
  WARNING: 'warning',
  INFO: 'info',
} as const;
export type ToastSeverity = (typeof ToastSeverity)[keyof typeof ToastSeverity];

export interface ToastMessage {
  id: number;
  severity: ToastSeverity;
  summary: string;
  detail: string;
  life: number;
}

export const TOAST_ICONS: Record<ToastSeverity, string> = {
  success: 'check_circle',
  error: 'error',
  warning: 'warning',
  info: 'info',
};

export const TOAST_COLORS: Record<ToastSeverity, { accent: string; bg: string; icon: string }> = {
  success: {
    accent: 'bg-emerald-500',
    bg: 'bg-emerald-500/10 dark:bg-emerald-500/15',
    icon: 'text-emerald-500',
  },
  error: {
    accent: 'bg-red-500',
    bg: 'bg-red-500/10 dark:bg-red-500/15',
    icon: 'text-red-500',
  },
  warning: {
    accent: 'bg-amber-500',
    bg: 'bg-amber-500/10 dark:bg-amber-500/15',
    icon: 'text-amber-500',
  },
  info: {
    accent: 'bg-sky-500',
    bg: 'bg-sky-500/10 dark:bg-sky-500/15',
    icon: 'text-sky-500',
  },
};
